import { r as reactDom } from './common/index-4bf81431.js';
import './common/_commonjsHelpers-a3307dcf.js';
import './common/index-2e5f2345.js';



var render = reactDom.render;
export { render };
